/* eslint-disable */
import router from './plugins/router'
import { format } from 'path'
router.beforeEach((to, from, next) => {
  let login = localStorage.getItem('token')
  let role = localStorage.getItem('role')
  let path = to.path
  if (path === "/login") {
    next()
    return
  }
  if (login) {
    // if (role === 'APP' && path === '/dashboard/auditlog') {
    //   next({
    //     path: from.path
    //   })
    //   return
    // }
    if (path) {
      next()
      return
    }
  } else {
    next({
      path: "/login"
    })
  }
})
